




































































































import { Component, Vue } from 'vue-property-decorator'
import { getCustomerList, rechargeCustomer } from '@/api/customer'
import Empty from '@/components/Empty/index.vue'

@Component({
  name: 'Customer',
  components: { Empty }
})
export default class extends Vue {
  private name = ''
  private phone = ''
  private counts = 0
  private page = 1
  private pageSize = 10
  private tableData = []
  private isSearch = false
  private rechargeVisible = false
  private rechargeLoading = false
  private rechargeAmount = ''
  private rechargeRemark = ''
  private currentCustomer: any = null

  created() {
    this.init()
  }

  initFun() {
    this.page = 1
    this.init()
  }

  private async init(isSearch?: boolean) {
    this.isSearch = !!isSearch
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      name: this.name || undefined,
      phone: this.phone || undefined
    }
    try {
      const res: any = await getCustomerList(params)
      if (String(res.data.code) === '1') {
        this.tableData = res.data.data.records
        this.counts = res.data.data.total
      }
    } catch (err) {
      this.$message.error('请求出错了：' + (err && err.message ? err.message : err))
    }
  }

  openRecharge(row: any) {
    this.currentCustomer = row
    this.rechargeAmount = ''
    this.rechargeRemark = ''
    this.rechargeVisible = true
  }

  async submitRecharge() {
    const amount = parseFloat(this.rechargeAmount)
    if (!amount || amount <= 0) {
      this.$message.warning('请输入有效的充值金额')
      return
    }
    this.rechargeLoading = true
    try {
      const res: any = await rechargeCustomer({
        userId: this.currentCustomer.id,
        amount,
        remark: this.rechargeRemark
      })
      if (String(res.data.code) === '1') {
        const gained = res.data.data && res.data.data.lotteryChancesGained
        const tip = gained > 0 ? `充值成功，赠送 ${gained} 次抽奖机会` : '充值成功'
        this.$message.success(tip)
        this.rechargeVisible = false
        this.init()
      } else {
        this.$message.error(res.data.msg || '充值失败')
      }
    } catch (err) {
      this.$message.error('请求出错了：' + (err && err.message ? err.message : err))
    } finally {
      this.rechargeLoading = false
    }
  }

  handleSizeChange(val: number) {
    this.pageSize = val
    this.init()
  }

  handleCurrentChange(val: number) {
    this.page = val
    this.init()
  }
}
